module.exports = __webpack_public_path__ + "static/endless_sphere-d6a639c604c188eaa1854fc935815ab4.webp";